import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Movimento Estoque Central',
  path: '/merenda/mermovimentoestoquecentral',
  name: 'mermovimentoestoquecentral',
  component: () => import('@/views/merenda/mermovimentoestoquecentral/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOCENTRALNOVO_MENU_1900200450],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Movimento Estoque Central',
  path: '/merenda/mermovimentoestoquecentral/cadastro/:id?',
  parent: 'mermovimentoestoquecentral',
  name: 'mermovimentoestoquecentral_create',
  component: () => import('@/views/merenda/mermovimentoestoquecentral/IncluirEditar.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOCENTRALNOVO_MENU_1900200450],
  },
  goesToMenu: true,
 },
 {
  description: 'Itens do Movimento Estoque Central',
  path: '/merenda/mermovimentoestoquecentral/:id/itens',
  parent: 'mermovimentoestoquecentral',
  name: 'mermovimentoestoquecentral_itens',
  component: () => import('@/views/merenda/mermovimentoestoquecentral/Itens.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOCENTRALNOVO_MENU_1900200450],
  },
  goesToMenu: false,
 },
]
